import { useState } from 'react';
import MonthSelector from './MonthSelector/MonthSelector';
import YearSelector from './YearSelector/YearSelector';
type CalendarMonthYearSelectorProps = {
    currentDate: Date;
    onSelection: (year: number, month: number) => void;
};

export default function CalendarMonthYearSelector({
    currentDate,
    onSelection,
}: CalendarMonthYearSelectorProps) {
    const [selectedYear, setSelectedYear] = useState<number>(
        currentDate.getFullYear(),
    );
    const [_, setSelectedMonth] = useState<number>(currentDate.getMonth());
    const [showMonthPicker, setShowMonthPicker] = useState(false);

    const handleYearSelection = (year: number) => {
        setSelectedYear(year);
        setShowMonthPicker(true);
    };

    const handleMonthSelection = (month: number) => {
        setSelectedMonth(month);
        setShowMonthPicker(false);
        onSelection(selectedYear, month + 1);
    };

    const Selector = showMonthPicker ? (
        <MonthSelector
            year={selectedYear}
            onYearChange={(year: number) => setSelectedYear(year)}
            onMonthSelection={handleMonthSelection}
        />
    ) : (
        <YearSelector
            onYearSelection={handleYearSelection}
            selectedYear={selectedYear}
        />
    );

    return <>{Selector}</>;
}
